export default __webpack_public_path__ + "static/media/soulstrike.59483c8f.png";